export type TargetType = '_self' | '_blank' | '_parent' | '_top';

export const openWindow = (
    fileURL: string | URL,
    target: TargetType = '_blank',
    windowFeatures = 'noopener,noreferrer',
) => {
    window.open(fileURL, target, windowFeatures);
};
